export default __webpack_public_path__ + "static/media/pills.614ab363.png";